import React from 'react'

function ZIndex() {
  return (
    <>
        <h2>Custom Z-Index</h2>
        <br/>
        <code>cust-z-ind-[value]</code>
    </>
  )
}

export default ZIndex